<template>
  <DashboardTemplate class="set-assignment">
    <div class="text-left">
      <h4 class="text-font-18 mg-t-less">วิชาที่ {{ subject.index }} {{ subject.name }}</h4>
    </div>
    <el-row v-loading="loading" :gutter="30" class="pd-b-4">
      <el-col
        v-for="(item, index) in assignmentListSort"
        :key="item._id"
        :span="24"
        :md="12"
      >
        <AssignmentCard
          :number="index + 1"
          :title="item.name"
          :description="item.description"
          :fileList="item.attach"
          :id="item._id"
          :subjectId="subjectId"
          :courseId="courseId"
          :closeDay="item.durationTime.close"
        />
      </el-col>
    </el-row>
  </DashboardTemplate>
</template>

<script>
import DashboardTemplate from "@/template/DashboardTemplate";
import AssignmentCard from "@/components/assignment/AssignmentCard";
import { HTTP } from "@/service/axios.js";

export default {
  props: {
    routeParams: {
      type: Object,
      default: null,
    },
  },
  components: {
    DashboardTemplate,
    AssignmentCard,
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
    courseList() {
      return this.$store.state.courseList;
    },
    assignmentListSort() {
      let sort = this.assignmentList.sort((a, b) => {

        if ( Date.now() > new Date(a.durationTime.close).getTime()
        ) {
          return 1;
        }
        return -1;
      });
      return sort;
    },
  },
  data() {
    return {
      subjectId: "",
      courseId: "",
      assignmentList: [],
      course: "",
      subject: "",
      loading: true,
    };
  },
  mounted() {
    this.setParams();
    this.fetchCourseList();
    this.fetchSubjectId();
  },
  methods: {
    setParams() {
      if (this.routeParams != null) {
        if (typeof this.routeParams.subjectId != "undefined") {
          this.subjectId = this.routeParams.subjectId;
          this.courseId = this.routeParams.courseId;
        }
      }
    },
    fetchCourseList() {
      let obj = {
        token: this.token,
      };
      this.$store.dispatch("FETCH_COURSE_LIST", obj);

      let filter = this.courseList.filter(
        (filter) => filter._id == this.$route.query.courseId
      );

      if (filter.length > 0) {
        this.course = filter[0];
        let course = filter[0].subject.filter(
          (filter) => filter._id == this.$route.query.subjectId
        );
        if (course.length > 0) {
          this.subject = course[0];
        }
      }
    },
    fetchSubjectId() {
      let obj = {
        subjectId: this.subjectId,
      };

      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      HTTP.post(`get/subject`, obj)
        .then((res) => {
          
          if (res.data.success) {
            this.assignmentList = res.data.obj.assignment;
          } else {
            this.alertFailError();
          }
        })
        .catch((e) => {
          this.alertCatchError(e);
          console.log("fetchSubjectId error", e);
        })
        .finally(() => {
          setTimeout(() => {
            this.loading = false;
          }, 500);
        });
    },
  },
};
</script>
